<template>
  <div class="goods">
    <van-nav-bar
      :title="titleName"
      :left-text="$t('indexdata.Return')"
      left-arrow
      @click-left="onClickLeft"
      class="nav_title"
      >
       <template #right>
         <language :class="{active:isactive}"></language>
        <!-- <van-button type="primary" :text="$t('index.language')" @click="show = true"  style="height: 46px;right:-16px" /> -->
      </template>
      </van-nav-bar>
      <van-overlay :show="show" @click="show = false">
          <div class="wrapper" @click.stop>
            <div class="block" style="padding:20px 30px;border-radius: 10px;">
              <van-radio-group v-model="radio">
                <van-radio
                  v-for="(item,index) in sendItems"
                  :key="index"
                  class="radio_item"
                  :name="item.id"
                  @click="changePay(item.id)"
                >{{item.name}}</van-radio>
              </van-radio-group>
            </div>
          </div>
        </van-overlay>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item_head,index_head) in (goods.imgs||'').split(',')" :key="index_head">
        <van-image :src="item_head" class="header_img"></van-image>
      </van-swipe-item>
    </van-swipe>

    <van-cell-group>
      <van-cell :border="false">
         <div class="goods-price">
            {{$t('Pay.money')}}{{ formatPrice(goods.price) }}
            <!-- <span class="source">原價:{{ formatPrice(goods.oriPrice) }}</span> -->
        </div>
        <div class="goods-brief">{{goods.brief}}</div>
        <div class="goods-title">{{goods.prodName}}</div>
      </van-cell>
      <!-- <van-cell class="border"> -->
        <!-- <div class="sku_line_item">
          <span style="flex:1">{{$t('Product_details_page.guarantee')}}:</span>
          <span>{{$t('Product_details_page.guarantee_texts')}}</span>
        </div> -->
      <!-- </van-cell> -->
      <van-cell>
        <!-- <div class="sku_line_item"> -->
          <!-- <span style="flex:1">已選：{{selectedSku.name}}</span> -->
          <!-- <span style="margin-right:24px;">{{$t('Product_details_page.numbertext')}}：{{selectedNum}}</span> -->
          <!-- <van-stepper v-model="selectedNum" /> -->
        <!-- </div> -->
      </van-cell>
    </van-cell-group>

    <!-- <div style="background: #f8f8f8;">
      <van-divider :style="{ color: '#7c7d7d', padding: '8px 16px', margin:'0px'}">套餐詳情</van-divider>
    </div> -->
    
    <div style="background: #f8f8f8;">
      <van-divider :style="{ color: '#7c7d7d', padding: '8px 16px', margin:'0px'}">{{$t('detail.goods_detail')}}</van-divider>
    </div>

    <div class="content" :style="{width:'100%',overflow: 'hidden'}" v-html="goods.content"></div>
     <div class="site">
        <span v-for="(item,index) in siteList" :key="index" @click="toDetail(item.id)">
          {{item.title}}
          <span v-if="index<(siteList.length-1)">|</span>
        </span>
      </div>
    <!-- <div style="margin-top:0.4rem" v-for="(item,index) in imgList" :key="index">
      <van-image :style="{width:'100%'}" fit="scale-down" :src="item" />
    </div> -->
    <van-goods-action>
      <van-goods-action-icon icon="wap-home" @click="home">{{$t('indexdata.index')}}</van-goods-action-icon>
      <van-goods-action-icon
        icon="cart-o"
        @click="onClickCart"
        :info="count ==0?'':count"
      >{{$t('detail.cart')}}</van-goods-action-icon>
      <!-- <van-goods-action-button type="warning" @click="addCart">{{$t('detail.add_cart')}}</van-goods-action-button> -->
        <!-- <van-goods-action-button type="warning" @click="addCarts">{{$t('detail.add_cart')}}</van-goods-action-button> -->
      <van-goods-action-button type="danger" @click="cartShow=true">{{$t('detail.buy_now')}}</van-goods-action-button>
    </van-goods-action>
    <!-- <van-sku
      v-model="show"
      :sku="sku"
      :goods="skuGoods"
      :buy-text="$t('detail.buy_now')"
      :add-cart-text="$t('detail.add_cart')"
      @buy-clicked="onBuyClicked"
      @add-cart="onAddCartClicked"
      @stepper-change="stepperChange"
      @sku-selected="skuSelected"
    /> -->

    <van-action-sheet v-model="cartShow" :title="$t('Product_details_page.Select_product_specification')" class="sheet">
        <van-row class="title">
          <div class="name"><span>{{comboList.title}}</span></div>
          <div>
            <span class="money">{{$t('Pay.money')}}{{ formatPrice(comboList.price) }}</span>
            <!-- <span class="orign">{{ formatPrice(comboList.oriPrice) }}</span> -->
          </div>
        </van-row>
        <div class="cont" v-if="cartShow">
          <van-row class="comboSelect" >
              <div class="name"><span>{{$t('Product_details_page.Package_selection')}}:</span></div>
              <van-row  class="list"> 
                  <van-tag 
                    plain 
                    v-for="(itemc,indexc) in goods.comboParams" :key="indexc"
                    :type="comboList.index==indexc?'danger':'primary'"
                    :color="comboList.index==indexc?'': '#dcdfe6'" 
                    :text-color="comboList.index==indexc?'': '#94979c'"
                    @click="toSelectCombo(indexc,itemc.title,itemc.price,itemc.oriPrice)"
                    >
                      {{itemc.title}}
                  </van-tag>
              </van-row>
          </van-row>
          <div class="combo"
            v-for="(item,index) in selectComboList.comboProds" 
            :key="index"
          > 
            <van-row class="goodSheet" type="flex">
              <van-col style="width: 55%;">
                <van-image
                  width="180"
                  height="180"
                  fit="scale-down"
                  :src="pic[index]"
                  />
              </van-col>
              <van-col class="skuName">
                  <div class="name">
                     <span>{{properties[index]}}
                    </span>
                  </div>
              </van-col>
            </van-row>
             <van-row style="width: 80%;margin: 0 10%;font-size: 0.6rem;font-weight: 550;color: #736868">
              <div class="name"><span>{{item.prodName}}</span></div>
            </van-row>
            <van-row v-for="(itemp,indexp) in item.productProps" :key="indexp">
               <!-- <van-row v-if="imageUrlStatus(itemp.prodPropValues)" style="width: 90%;margin: 0 5%;">
                  <van-cell-group :border="false">
                    <van-cell :border="false">
                      <div class="sku_line_item">
                        <span style="flex:1">{{itemp.propName}}</span>
                      </div>
                    </van-cell>
                  </van-cell-group>
                  <van-row class="grid"  type="flex" style=" flex-wrap:wrap" >
                      <van-col 
                        class="grid_item" 
                        v-for="(item_img,index_img) in itemp.prodPropValues" 
                        :class="[selectSkuImgList[index]==index_img?'select':'']" 
                        :key="index_img"
                        @click="toSelectSkuImg(index,index_img,indexp,item_img.valueId)"
                      >
                      <van-image class="van_img" :src="item_img.imageUrl" />
                  </van-col>
              </van-row>
              </van-row>
              
              <van-row style="width: 90%;margin: 0 5%;" v-else> -->
              <van-row style="width: 90%;margin: 0 5%;">
                <van-cell-group :border="false">
                  <van-cell :border="false">
                    <div class="sku_line_item">
                      <span style="flex:1">{{itemp.propName}}</span>
                    </div>
                  </van-cell>
                </van-cell-group>
                <van-tag 
                  v-for="(itemm,indexx) in itemp.prodPropValues" 
                  plain
                  :key="itemm.skuId" 
                  :type="selectSkuNList[index][indexp]==indexx?'danger':'primary'" 
                  :color="selectSkuNList[index][indexp]==indexx?'': '#dcdfe6'" 
                  :text-color="selectSkuNList[index][indexp]==indexx?'': '#94979c'"
                  class="tag"
                  @click="toSelectSkuName(index,indexx,indexp,itemm.valueId,item,itemp,itemm)"
                >{{itemm.propValue}}</van-tag>
              </van-row>
            </van-row>

          </div>
        </div>
        
        <van-goods-action style="z-index:99">
          <van-goods-action-button type="danger" :disabled='flag' :text="$t('Product_details_page.Buy_now')" @click="buyNow" />
        </van-goods-action>
    </van-action-sheet>
   


  </div>
</template>

<script>
import { Swipe, SwipeItem,Toast,Grid, GridItem,Tag,Image,Lazyload, Stepper ,ActionSheet, GoodsAction, GoodsActionIcon, GoodsActionButton,NavBar } from 'vant';
import { mapMutations, mapState } from 'vuex';
import { findIndex, remove, cloneDeep } from 'lodash';
import goods from '@/api/goods';
import { getQueryVariable} from '@/utils/index';
import language from './index/common/Language';
import { moneys } from "../../static/moneyString"
export default {
  components: {language},
  data() {
    return {
      moneysString:'',
      sku: {
        tree: [],
        list: [],
        price: '11', // 默认价格（单位元）
        stock_num: 227, // 商品总库存
        collection_id: 2261, // 无規格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无規格商品
        hide_stock: false, // 是否隐藏剩余库存
      },
      show: false,
      goods: {
        transport: {},
        skuList: [{}],
        comboParams:[{}],
      },
      skuGoods: {},
      selectedSku: {},
      selectedNum: 1,//商品數量的选择
      imgList:[],
      selectSkuNList:[[]],  //套餐中选中的規格数组
      skuImgList:[[]], //規格商品的图片
      cartShow:false , //购物车页面
      comboList:{  //套餐详情
        title:'', //套餐标题
        oriPrice:'',  //套餐原价
        price:'',  //套餐价格
        index:0,
      },
      titleName:'',//标题名字
      comboParams:[],
      selectComboList:[], //选中的套餐的产品列表
      selectSkuImgList:[],//选中的套餐的产品列表--颜色
      selectSkuImgTextList:[[]],//选中的套餐的产品列表--文字
      selSkuNameList:[],//选中的产品的规格列表
      skuIndexList:[[]],//选中的产品的规格列表
      skuId :[],
      pic:[],
      properties :[],
      shopId:'',
      siteList:[],
      flag:false,
      Lumpuhkan:[],
      sendPop: false,
      show:false,
      radio: '1',
      sendItems: [
        {
          id: '1',
          name: '中文繁體',
        },
        {
          id: '2',
          name: '中文简体',
        },
        {
          id: '3',
          name: 'English',
        },
        {
          id: '4',
          name: 'Malay',
        },
      ],
      isactive:true
    };
    
  },
  computed: {
    count: {
      get() {
        let cartGoods = this.$store.state.goods.shopCardGoods;
        let count = cartGoods.reduce((total, item) => total + item.num, 0);
        return count;
      },
    },
  },
  created() {
    var str=this.$session.get('moneyString');
    this.moneysString=moneys[str];
    Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
     let shopIds = sessionStorage.getItem("shopId") || this.$store.state.user.regionData.shopId;
    //  this.$Fbq.getFbqId('',shopIds)
    this.titleName = this.$store.state.designer.titleName;
    let param1 = this.$route.params || {};
    let hrefs = window.location.href.split('#');
    let spilt= hrefs[1].split('?');
    // var url = location.search; //获取问号后面的参数
    // console.info('url:',hrefs[1])
    // let spilt= window.location.href;
    let sysUserId,orderSource
    if(spilt.length>1){
      sysUserId = getQueryVariable(spilt[1], 'sysUserId')
      orderSource=getQueryVariable(spilt[1], 'orderSource')
      // console.info(sysUserId,'------',orderSource)
      this.$session.set('sysUserId',sysUserId?sysUserId:'');  //获取userId
      this.$session.set('orderSource',orderSource?orderSource:'');
    }
    
    let param = {
      prodId:param1.prodId
    }
    if(param1.type=='tag'){  //商品列表中的详情接口
      goods.tagProdInfo(param).then((res) => {
        if(res.shopId){
           this.shopId = res.shopId
           this.$store.commit('designer/setShopId', res.shopId);
        }
        if(res.isPlay==1){//0表示不显示,1 显示
          this.getSiteList(res.shopId)
        }
        if(res.dyRop){
          this.dyRop(res.dyRop)
        }
        Toast.clear();
        this.comboParams =res.comboParams
        this.selectComboList =  this.comboParams[this.comboList.index];
        let selectComboList = cloneDeep(this.selectComboList);
        this.selectComboList = selectComboList
        this.changeSelList()

        //默认选中的套餐
        if(res.comboParams[0].title){
          this.comboList.title = res.comboParams[0].title
        }
        if(res.comboParams[0].oriPrice){
          this.comboList.oriPrice = res.comboParams[0].oriPrice
        }
        if(res.comboParams[0].price){
         this.comboList.price = res.comboParams[0].price
        }
        if(res.comboParams[0].index){
          this.comboList.index = res.comboParams[0].index
        }
        this.goods = res;
        this.getSkuList()
      
      });

    }else{
      goods.goodsInfo(param.prodId).then((res) => {
        if(res.shopId){
           this.shopId = res.shopId
           this.$store.commit('designer/setShopId', res.shopId);
        }
        if(res.isPlay==1){//0表示不显示,1 显示
          this.getSiteList(res.shopId)
        }
        if(res.dyRop){
          this.dyRop(res.dyRop)
        }
       
        Toast.clear();
        // console.log('====res=====', res);
        this.comboParams =res.comboParams
        this.selectComboList =  this.comboParams[this.comboList.index];
        let selectComboList = cloneDeep(this.selectComboList);
        this.selectComboList = selectComboList
        this.changeSelList()

        //默认选中的套餐
        if(res.comboParams[0].title){
          this.comboList.title = res.comboParams[0].title
        }
        if(res.comboParams[0].oriPrice){
          this.comboList.oriPrice = res.comboParams[0].oriPrice
        }
        if(res.comboParams[0].price){
         this.comboList.price = res.comboParams[0].price
        }
        if(res.comboParams[0].index){
          this.comboList.index = res.comboParams[0].index
        }
        this.goods = res;
        this.getSkuList()
      
      });

    }


    //检测滑动到底部
    	window.onscroll = function(){
     		//变量scrollTop是滚动条滚动时，距离顶部的距离
     		var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
     		//变量windowHeight是屏幕可用工作区高度
     		var windowHeight = window.screen.availHeight 
     		//变量scrollHeight是滚动条的总高度
     		var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
        //滚动条到底部的条件
        if(scrollTop+windowHeight==scrollHeight){
            fbq('track', 'AddToCart');
         }   
       }
     

  },
  methods: {
    getSiteList(shopId){  //获取站点列表
      goods.topSiteList({shopId:shopId}).then((res) => {
              this.siteList = res
            });
    },
    toDetail(id){  //点击站点去到相对应的页面
        this.$router.push({ name: 'siteDetail', params: { id: id} });
    },
    imageUrlStatus(prodPropValues){  //判断规格中是否有图片
      let status = false
      prodPropValues.forEach((item,index)=>{
        if(item.imageUrl){
         status =  true
        }
      })
      return status
    },
    changeSelList(){  //初始化辅助数组
        if(this.selectComboList.comboProds){
              this.selectComboList.comboProds.forEach((itemc,indexc)=>{
              this.selectSkuImgList.push(0)
              this.selectSkuNList[indexc] = new Array();
              this.skuIndexList[indexc] =new Array()
              itemc.productProps.forEach((item_p,index_p)=>{
                this.selectSkuNList[indexc].push(0)
                this.skuIndexList[indexc][index_p]=item_p.prodPropValues[0].valueId
              })
             
          })
          }
    },
     toSelectSkuName(index,indexx,indexp,valueId,item,itemp,itemm){  //选中的sku的名字
    //  console.log(index,indexx,indexp,valueId,item,itemp,itemm)
     this.selectSkuNList[index][indexp]=indexx
      let arr = cloneDeep(this.selectSkuNList)
      this.selectSkuNList=arr
      this.skuIndexList[index][indexp]=valueId
       this.getSkuList(arr)
        let propertiesStr = this.skuIndexList[index].join(',')
        item.skuList.forEach((ele,i)=>{
          if(ele.propertiesId == propertiesStr){
            // console.log('ele.status==0',ele)
            if(ele.status==0){
              Toast('该规格已售空');
              this.flag=true
              if(this.Lumpuhkan.length<=0){//如果数组没有， 那么先保存第一次点击的值
                var arr={'index':index,'indexp':[indexp]}
                this.Lumpuhkan.push(arr);
              }else{    //如果有， 就判断下当前的商品 颜色和尺码
                var hakim=-1;
                this.Lumpuhkan.forEach((key,val)=>{
                    if(key.index==index&&key.indexp.indexOf(indexp)==-1){//判断这个数组对象对应商品是否有颜色和尺码没有就添加进去
                        this.Lumpuhkan[val].indexp.push(indexp)   //保存操作的选项
                        // console.info('没有规格',key,val)
                    }
                    if(key.index==index){  
                       hakim=index;
                    }
                })
                if(hakim==-1){  //如果没有， 那么就直接保存当前的操作
                  var arr={'index':index,'indexp':[indexp]}
                  this.Lumpuhkan.push(arr);
                }
              }
            }
            if(ele.status==1){
              this.flag=false
              this.Lumpuhkan.forEach((key,val)=>{
                  if(key.index==index){//判断这个数组对象对应商品是否有颜色和尺码 有就将对应的按钮标识删除
                    //  console.info('有这个',key,val)
                     this.Lumpuhkan.splice(this.Lumpuhkan.indexOf(val),1);
                  }
              })
            }
          }
        })
        if(this.Lumpuhkan.length>0){
          this.flag=true
        }
      // console.info('最终',this.Lumpuhkan)
      // propertiesId
      // let arr2  = cloneDeep(this.skuImgList)
      // arr2[this.comboList.index][index]=pic
      // this.skuImgList=arr2
    },
    toSelectSkuImg(index,index_img,indexp,valueId){  //选中的sku的图片
      this.selectSkuImgList[index]=index_img
      let selectSkuImgList = cloneDeep(this.selectSkuImgList);
      this.selectSkuImgList = selectSkuImgList
      this.skuIndexList[index][indexp]=valueId
      this.getSkuList()
    },
    getSkuList(){
      let selectCombo = this.selectComboList
      var selectList=[] 
      selectList = this.selectComboList.comboProds
      this.skuIndexList.forEach((item,index)=>{
        let skuIndex='' 
        item.forEach((item_m,index_m)=>{
          skuIndex =skuIndex+ item_m+','
        })
        skuIndex=(skuIndex.substring(skuIndex.length-1)==',')?skuIndex.substring(0,skuIndex.length-1):skuIndex;
        selectList[index].skuList.forEach((item_s,index_s)=>{
          if(skuIndex==item_s.propertiesId)
          {
            this.skuId[index] = item_s.skuId
            this.pic[index] = item_s.pic
            this.properties[index] = item_s.properties
          }

        })
      })
    },
    onClickLeft(){
      this.$router.go(-1)
    },
    toSelectCombo(indexc,title,price,oriPrice){  //选择套餐
        this.Lumpuhkan=[];  //清空商品选择
        this.comboList.index=indexc
        this.comboList.title=title
        this.comboList.price=price
        this.comboList.oriPrice=oriPrice
        this.selectComboList=this.comboParams[indexc]
        let arr = cloneDeep(this.selectComboList)
        this.selectComboList=arr
             //选中的套餐的产品列表
      this.properties = [],
      this.skuId= [],
      this.pic=[],
      this.selectSkuNList=[[]]
      this.selectSkuImgList=[]
      this.skuIndexList=[[]]
      this.changeSelList()
      this.getSkuList()
        // let comboList = cloneDeep(this.comboList)
        // this.comboList= comboList




    },
    addCarts(){   //立即購買
      this.cartShow = true
    },
    home() {
      this.$router.replace('/');
    },
    convertSku(skuList) {
      let v = [];
      let list = [];
      skuList.forEach((item, index, array) => {
        let vItem = {
          id: item.skuId,
          name: item.skuName,
          imgUrl: item.pic,
        };
        v.push(vItem);
        let listItem = {
          id: item.skuId, // skuId，下单时后端需要
          price: item.price * 100, // 价格（单位分）
          sku_id: item.skuId, // 規格类目 k_s 为 s1 的对应規格值 id
          stock_num: item.stocks, // 当前 sku 组合对应的库存
        };
        list.push(listItem);
      });
      this.sku = {
        tree: [{ k: '規格', k_s: 'sku_id', v }],
        list,
        price: this.goods.price,
        stock_num: this.goods.totalStocks, // 商品总库存
      };
    },
    ...mapMutations('goods', {
      addShopCardGoods: 'addShopCardGoods',
      refreshOrderGoods: 'refreshOrderGoods',
    }),
    formatPrice(price) {
      return  + price;
    },
    getTransName(transport) {
      if (transport != undefined && transport != '') {
        return transport.transName;
      }
      return '';
    },
    onClickCart() {
      this.$router.push('/cart');
    },
    onBuyClicked(e) {
      if (e.selectedSkuComb == null) {
        Toast('請選擇一种規格');
        return;
      }
      let buyGoods = cloneDeep(this.goods);
      buyGoods.selectedSkuId = e.selectedSkuComb.sku_id;
      buyGoods.selectedSkuName = this.getSkuName(e.selectedSkuComb.sku_id);
      buyGoods.selectedSkuPrice = this.getSkuPrice(e.selectedSkuComb.sku_id);
      buyGoods['num'] = e.selectedNum;
      let goodsList = [buyGoods];
      this.refreshOrderGoods(goodsList);
      this.$router.push('/newOrder');
      this.show = false;
    },
    onAddCartClicked(e) {
      if (e.selectedSkuComb == null) {
        Toast('請選擇一种規格');

        return;
      }
      this.show = false;
      let buyGoods = cloneDeep(this.goods);
      buyGoods.selectedSkuId = e.selectedSkuComb.sku_id;
      buyGoods.selectedSkuName = this.getSkuName(e.selectedSkuComb.sku_id);
      buyGoods.selectedSkuPrice = this.getSkuPrice(e.selectedSkuComb.sku_id);
      buyGoods['num'] = e.selectedNum;
      this.addShopCardGoods(buyGoods);
      Toast(this.$t('tips.cart_success'));
    },

    getSkuName(skuId) {
      for (let i = 0; i < this.goods.skuList.length; i++) {
        if (this.goods.skuList[i].skuId === skuId) {
          return this.goods.skuList[i].skuName;
        }
      }
    },
    getSkuPrice(skuId) {
      for (let i = 0; i < this.goods.skuList.length; i++) {
        if (this.goods.skuList[i].skuId === skuId) {
          return this.goods.skuList[i].price;
        }
      }
    },
    addCart() {
      if (this.selectedSku.id == undefined || this.selectedSku.id == null) {
        // Toast('請選擇一种規格');
        this.show = true;
        return;
      }
      let buyGoods = cloneDeep(this.goods);
      buyGoods.selectedSkuId = this.selectedSku.id;
      buyGoods.selectedSkuName = this.selectedSku.name;
      buyGoods.selectedSkuPrice = this.getSkuPrice(this.selectedSku.id);
      buyGoods['num'] = this.selectedNum;
      this.addShopCardGoods(buyGoods);
      Toast(this.$t('tips.cart_success'));
    },
    buyNow() {
      // console.log('=====fbq=====',fbq)
      fbq('track', 'AddToCart');
      let buyGoods = cloneDeep(this.selectComboList.comboProds);
      buyGoods.forEach((item,index)=>{
          item.selectedSkuId = this.skuId[index];
         item.skuList.forEach((item_sku,index_sku)=>{
           if(item_sku.skuId==this.skuId[index]){
               item.selectedSkuPrice = item_sku.price;
               item.selectedSkuName = item_sku.properties;
           }
         })
         
          item.allPrice = this.selectComboList.price;
          item.selectedProdName = this.selectComboList.title;
          item.selectedProdId = this.goods.prodId;
          item['num'] = this.selectedNum;
      })
      this.refreshOrderGoods(buyGoods);
      this.$router.push('/orderStep3');
    },
    stepperChange(e) {
      // console.log('====goodsList=', e);
      this.selectedNum = e;
    },
    skuSelected(e) {
      // console.log('====goodsList=', e);
      if (this.selectedNum == 0) {
        this.selectedNum = 1;
      }

      this.selectedSku = e.skuValue;
    },
    dyRop(dyRop){  //抖音的像素
      sessionStorage.setItem('dyRop',dyRop)
      var ta = document.createElement('script'); 
      ta.type = 'text/javascript'; ta.async = true;
      ta.src = 'https://analytics.tiktok.com/i18n/pixel/sdk.js?sdkid='+dyRop;
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(ta, s);
    },
    changePay(item){
        this.show = false
        if(item==1){
          let locale = this.$i18n.locale  
          locale === 'null' ? this.$i18n.locale = 'tw' : this.$i18n.locale = 'tw'
        }else if(item == 2){
          let locale = this.$i18n.locale  
          locale === 'null' ? this.$i18n.locale = 'tw' : this.$i18n.locale = 'zh'
        }else if(item == 3){
          let locale = this.$i18n.locale  
          locale === 'null' ? this.$i18n.locale = 'tw' : this.$i18n.locale = 'en'
        }else{
          let locale = this.$i18n.locale  
          locale === 'null' ? this.$i18n.locale = 'tw' : this.$i18n.locale = 'ma'
        }
      },
  },
  // beforeRouteEnter(to, from, next) {
  //   next();
  // },
  // beforeRouteUpdate(to, from, next) {
  // },
  // beforeRouteLeave(to, from, next) {
  //   next();
  // },
};
</script>

<style lang="scss" scoped='scoped'>
.huise{
  background: black;
}
.goods {
  padding-bottom: 50px;
  .my-swipe{
    height: 15rem;
  }
  .header_img {
    width: 100%;
    height: 15rem;
  }
  .van-image__img {
    height: inherit;
  }
  &-title {
    font-size: 16px;
  }
  &-brief {
    font-size: 13px;
    color: #d85757;
  }
  &-price {
    color: #f44;
    font-size: 18px;
    .source{
      font-size: 10px;
      color: #868788;
      text-decoration:line-through;
      padding-left: 10px;
    }
  }
  .sku_line_item {
    display: flex;
    color: #7c7d7d;
    font-size: 12px;
    justify-content: space-between;
  }
  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }
  &-cell-group {
    margin: 15px 0;
    .van-cell__value {
      color: #999;
    }
  }
  &-tag {
    margin-left: 5px;
  }
}
.border{
    border-top: 0.2rem solid #f8f8f8;
    border-bottom: 0.2rem solid #f8f8f8;
    color: #7c7d7d;
}
.color{
  color: #7c7d7d;
}
.sheet{
    // height: 80%;
    // overflow-y: hidden;
    z-index: 2004;
    // padding-bottom: 2rem;
    .title{
      // height: 11%;
      width: 90%;
      padding: 2% 5%;
      border-bottom: 0.2rem solid #f5f5f5;
      span{
        font-size: 0.65rem;
        font-weight: 550;
      }
      // .name{
      //   padding-left: 0.2rem;
      // }
      .money{
        color: #ca2e2e;
      }
      .orign{
        font-size: 0.5rem;
        color: #868788;
        text-decoration:line-through;
        padding-left: 0.5rem;
      }
    }
    .cont{
      height: 60%;
      overflow-y: scroll;
      padding-bottom: 25%;
    }
}

.combo{
  padding-bottom: 15%;
  .goodSheet{
    width: 90%;
    margin: 2% 5%;
    .van-col{
        margin: 0 2%;
        line-height: 1.1rem;
    }
    .van-tag{
      margin: 0.2rem 0.1rem;
      height: 1rem;
    }
  }
  .grid{
        width: 90%;
        margin-left: 5%;
        // margin-top: 0.5rem;
        .grid_item{
          .van_img {
              width: 1.8rem;
              height: 1.8rem;
              padding: 0.2rem;
              border: 0.05rem solid #e4e4e4;
              margin: 0.2rem;
          }
        }
        .select{
          .van_img {
              width: 1.8rem;
              height: 1.8rem;
              padding: 0.2rem;
              border: 0.05rem solid #e4e4e4;
              margin: 0.2rem;
              border: 0.05rem solid  #ee0a24;
          }
        }
    }

}
.comboSelect{
    width: 90%;
    padding: 2% 3%;
    margin: 1%;
    border-bottom: 0.01rem solid #e2dfdf;
  .name{
    line-height: 1rem;
  }
  .list{
    .van-tag{
      margin: 0.2rem 0.1rem;
      height: 1rem;
    }
    .select{
          color: #ca2e2e;
    }
  }
}
.skuName{
    font-size: 0.65rem;
    font-weight: 550;
    color: black;
}

.tag{
  margin: 0.2rem 0.5rem; 
  height: 1rem;
}
.nav_title{
  .van-nav-bar__left{
    .van-icon{
      color: #6f6f73;
    }
    .van-nav-bar__text{
      color: #6f6f73;
    }
  }
}
.content p image{
  height: auto; 
}
.site{
  margin: 30px 0;
  text-align: center;
  padding: 0 30px;
  font-size: 14px;
}
.active{
  // height: 46px;
  // right:-16px
  margin: 0 -16px 2px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/GoodsCategoryDetail.vue